import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";

@Component({
  selector: "app-hcc-summary-by-provider",
  templateUrl: "./hcc-summary-by-provider.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HccSummaryByProviderComponent {
    filters: string[];
    dashboardType = LookerRiskDashboardType.HCC_SUMMARY_BY_PROVIDER;

    constructor() {
        this.filters = ["Projects", "Address", "Hcc", "Npi", "Products", "LOB", "RetrievalOwner", "ChaseTags"];
    }

}
